
import { Component, Vue } from "vue-property-decorator";
import * as models from "@/code/models";
// import * as Emp from "@/code/apis/api.employee";
import * as validate from "@/code/validation";
import { data } from "@/store/data";

// import { VueEditor } from "vue2-editor";
// import { Quill } from "vue2-editor";

export default Vue.extend({
  name: "home",
  components: {
    // VueEditor
  },
  data: () => ({
    questions: [] as any[],
    onboarding: 0,
    clickedQuestions: [1],
  }),
  watch: {},
  computed: {
    result() {
      let questionsResults = this.questions.map((x, i) => {
        if (x.submitAnswer) {
          const isCorrect =
            x.rightAnswers.every((val: any) => x.answers.includes(val)) &&
            x.rightAnswers.length == x.answers.length;
          return {
            questionNum: i + 1,
            result: isCorrect ? 1 : 0,
          };
        } else {
          return {
            questionNum: x.id,
            result: null,
          };
        }
      });
      let score =
        (questionsResults.filter((x) => x.result == 1).length /
          this.questions.length) *
        100;
      let maxQuestion = Math.max(...this.clickedQuestions);
      return {
        questionsResults,
        score,
        maxQuestion,
      };
    },
  },
  methods: {
    optionState(
      option: number,
      rightAnswers: number[],
      usersAnswers: number[]
    ) {
      // answer is correct
      if (rightAnswers.includes(option)) {
        return "green lighten-3";
      }

      // answer is not correct And user chose it
      else if (
        !rightAnswers.includes(option) &&
        usersAnswers.includes(option)
      ) {
        return "red lighten-3";
      } else {
        return "grey lighten-3";
      }
    },
    async getQuestions() {
      try {
        return new Promise<any[]>((resolve) => {
          setTimeout(() => {
            return resolve(data);
          }, 500);
        });
      } catch (error) {
        return [] as any[];
      }
    },
    next() {
      this.onboarding =
        this.onboarding + 1 === this.questions.length
          ? this.onboarding
          : this.onboarding + 1;
      this.clickedQuestions.push(this.onboarding + 1);
    },
    prev() {
      this.onboarding =
        this.onboarding - 1 < 0
          ? this.questions.length - 1
          : this.onboarding - 1;
    },
  },
  async created() {
    this.questions = await this.getQuestions();
    this.questions.map((x) => {
      Vue.set(x, "answers", [] as number[]);
      Vue.set(x, "submitAnswer", false);
    });
    console.log(this.result.questionsResults[0].result);
  },
});
